/**
 * Single builder for the central-body switch live announcement (Story 2.2, AC 9,
 * SC 4.1.3). All three switch entry points (the central-body control, the "Make
 * centre" button, and the drop-on-centre drag) call this one function so their
 * announcements cannot diverge (AD-2 identical-outcome intent). Display names are
 * supplied by the caller from `state` selectors, so this stays a pure string
 * helper with no `core` or store access (AD-2 layer table). English copy lives at
 * the ui boundary (AD-5).
 */
export function describeCentreSwitch(prevName: string, newName: string): string {
  return `${newName} is now the centre. ${prevName} is now an orbiting body.`;
}
